import PublicationComponent from "components/PublicationsComponent";

const PublicationStructure = () => {
  const publications = [
    {
      title: "Balanço Patrimonial da CNP Seguros Holding Brasil",
      description: "Exercício 2022",
      link: "/AreaAberta/Relatorios/balanco/balanco-patrimonial-cnp-2022.pdf",
      category: "Demonstrações Financeiras"
    },
    {
      title: "Balanço Patrimonial da CNP Seguros Holding Brasil",
      description: "Exercício 2021",
      link: "/AreaAberta/Relatorios/balanco/balanco-patrimonial-cnp-2021.pdf?_ga=2.246923532.92447727.1667843332-542798228.1660054478",
      category: "Demonstrações Financeiras"
    },
    {
      title: "Programa de Integridade CNP Seguros Holding Brasil",
      description: "Conheça o Programa de Integridade da CNP Brasil. Este documento reúne o conjunto de ações e medidas adotadas para combater a corrupção e garantir a ética, transparência e cumprimento das leis e regulamentos vigentes.",
      link: "/AreaAberta/Relatorios/Conformidade/Programa_de_Integridade_CNP_Seguros_Holding_Brasil.pdf",
      linkOtherLanguage: "/AreaAberta/Relatorios/Conformidade/Programa_de_Integridade_CNP_Seguros_Holding_Brasil_English.pdf",
      category: "Conformidade"
    },
    {
      title: "Guia de Uso Aceitável",
      description: "Conheça o Guia de Uso Aceitável dos Recursos Tecnológicos da CNP Brasil. Seu objetivo é orientar o uso seguro dos recursos tecnológicos disponibilizados para nossos clientes, fornecedores, parceiros de negócio e colaboradores.",
      link: "/AreaAberta/Relatorios/Conformidade/GUIA%20SGI%20004%2001%20-%20Guia%20de%20Uso%20Aceitável%20de%20Recursos%20Tecnológicos.pdf?_ga=2.153060785.92447727.1667843332-542798228.1660054478",
      category: "Conformidade"
    },
    {
      title: "Código de Ética e Conduta CNP Assurances",
      description: "Conheça o Código de Ética e Conduta da CNP Assurances.",
      link: "/AreaAberta/Relatorios/Conformidade/Code%20de%20conduite%20Groupe%20C@pEthic%20-%20Site%20institutionnel%20-%20anglais%20-%20avril%202022.pdf?_ga=2.176611757.92447727.1667843332-542798228.1660054478",
      category: "Conformidade"
    },
    {
      title: "Código de Ética e Conduta CNP Seguros Holding Brasil",
      description: "Conheça o Código de Ética e Conduta da CNP Seguros Holding Brasil",
      link: "/AreaAberta/Relatorios/Conformidade/CNP_21_Código_de_Ética.pdf?_ga=2.176611757.92447727.1667843332-542798228.1660054478",
      category: "Conformidade"
    },
    {
      title: "Código de Ética e Conduta dos Prestadores de Serviços e Parceiros de negócio da CNP Brasil",
      description: "Conheça as diretrizes de Ética e Conduta direcionadas aos Prestadores de Serviços, Fornecedores e Parceiros de negócio da CNP Brasil",
      link: "/AreaAberta/Relatorios/Conformidade/CNP_21_Código_de_Ética_Fornecedor.pdf?_ga=2.207677082.92447727.1667843332-542798228.1660054478",
      category: "Conformidade"
    },
    {
      title: "Cartilha de Prevenção à Fraude",
      description: "Apresenta conceito, estrutura preventiva e direciona sobre procedimentos a serem adotados em casos de suspeita ou identificação de fraude.",
      link: "/AreaAberta/Relatorios/Conformidade/CNP_CARTILHA_FRAUDE_0811.pdf?_ga=2.216509086.92447727.1667843332-542798228.1660054478",
      category: "Conformidade"
    },
    {
      title: "Cartilha de Prevenção à Lavagem de Dinheiro",
      description: "Apresenta conceito, estrutura preventiva e direciona sobre procedimentos a serem adotados em casos de suspeita ou identificação de fraude.",
      link: "/AreaAberta/Relatorios/Conformidade/CARTILHA_LAVAGEM_DINHEIRO%200811%20vs%20FINAL_%20INTERNET.pdf?_ga=2.216509086.92447727.1667843332-542798228.1660054478",
      category: "Conformidade"
    },
    {
      title: "Cartilha Anticorrupção",
      description: "Apresenta o conceito, estrutura preventiva e procedimentos a serem adotados em casos de suspeita ou identificação de lavagem de dinheiro.",
      link: "/AreaAberta/Relatorios/Conformidade/CNP_CARTILHA_ANTI-CORRUPCAO_0811.pdf?_ga=2.174006315.92447727.1667843332-542798228.1660054478",
      category: "Conformidade"
    },
    {
      title: "Relatório de Ouvidoria de Consórcios do Primeiro Semestre de 2022",
      description: "Conheça o trabalho desenvolvido pela nossa ouvidoria de consórcio referente ao primeiro semestre de 2022.",
      link: "/AreaAberta/Relatorios/ouvidoria/REA%20OUVIDORIA%202022_sem1_CNP%20Consórcio_SITE.pdf?_ga=2.150463934.92447727.1667843332-542798228.1660054478",
      category: "Relatório de ouvidoria"
    },
    {
      title: "Relatório de Ouvidoria de Consórcios do Segundo Semestre de 2021",
      description: "Conheça o trabalho desenvolvido pela nossa ouvidoria de consórcio referente ao segundo semestre de 2021.",
      link: "/AreaAberta/Relatorios/ouvidoria/relatorio-ouvidoria-consorcios-segundo-semestre-2021.pdf?_ga=2.150463934.92447727.1667843332-542798228.1660054478",
      category: "Relatório de ouvidoria"
    },
    {
      title: "Política de Sustentabilidade",
      description: "Orientações para atuação da Companhia na incorporação da Responsabilidade Social, Ambiental e Climática.",
      link: "/AreaAberta/Relatorios/PO%20011%2009%20-%20Política%20de%20Sustentabilidade.pdf",
      category: "Sustentabilidade"
    },
    {
      title: "Relatório de Sustentabilidade 2024",
      description: "Confira os progressos da CSH na gestão de temas ambientais, sociais e de governança (ESG).",
      link: "/AreaAberta/Relatorios/Relatorio-de-Sustentabilidade-CNP-2024.pdf",
      category: "Sustentabilidade"
    },
    {
      title: "Relatório de Sustentabilidade 2023",
      description: "Confira os progressos da CSH na gestão de temas ambientais, sociais e de governança (ESG).",
      link: "/AreaAberta/Relatorios/Relatorio-de-Sustentabilidade-CNP-2023.pdf",
      category: "Sustentabilidade"
    },
    {
      title: "Relatório de Sustentabilidade 2022",
      description: "Conheça as iniciativas realizadas em 2022 nos âmbitos social, ambiental e de governança da CNP Brasil.",
      link: "/AreaAberta/Relatorios/Relatorio-de-Sustentabilidade-CNP-2022.pdf",
      category: "Sustentabilidade"
    },
    {
      title: "Relatório de Sustentabilidade 2021",
      description: "Conheça as iniciativas realizadas em 2021 nos âmbitos social, ambiental e de governança da CNP Brasil.",
      link: "/AreaAberta/Relatorios/Relatorio-de-Sustentabilidade-CNP-2021.pdf",
      category: "Sustentabilidade"
    },
    {
      title: "Relatório de Sustentabilidade 2020",
      description: "Conheça as iniciativas realizadas em 2020 nos âmbitos social, ambiental e de governança da CNP Brasil.",
      link: "/AreaAberta/Relatorios/Relatorio-de-Sustentabilidade-Caixa-Seguradora-2020.pdf?utm_medium=canais-proprios&utm_source=area-aberta&utm_campaign=site-cnp&utm_term=ae378&utm_content=corporativo-relatorio-de-sustentabilidade-cs-2020",
      category: "Sustentabilidade"
    },
  ];
  return (
    <PublicationComponent key={publications.keys()} publications={publications} />
  );
};

export default PublicationStructure;
